import { Params } from '@angular/router';

/**
 * Parametr `typeView` w adresie ma dwa znaczenia. Na stronie wyników wyszukiwarki
 * globalnej to wybrana kategoria wyników (nazwa widoku, np. `artistView`), i tylko
 * takie wartości wolno wnosić do stanu listy. Wartość spoza rejestru znanych widoków
 * należy do innego mechanizmu (tryb wyświetlania listy) i lista jej nie interpretuje.
 */
export const readViewNameFromParams = (
  params: Params | null | undefined,
  knownViewNames: string[],
): string | null => {
  const typeView = params?.['typeView'];

  return typeof typeView === 'string' && knownViewNames.includes(typeView) ? typeView : null;
};

/**
 * Widok wysyłany w żądaniu listy. Pierwsze żądanie powstaje przed nadejściem danych,
 * czyli przed ustaleniem aktywnej zakładki — dopóki komponent jej nie zna, żądanie musi
 * nieść kategorię z adresu, inaczej wybrana kategoria i numer strony przepadają przy
 * wejściu pod zapamiętany adres listy (powrót do listy, udostępniony odnośnik).
 *
 * Brak wartości oznacza pominięcie parametru w żądaniu — `TableParams.toPlainObject()`
 * odfiltrowuje pola bez wartości.
 */
export const resolveRequestTypeView = (
  activeTab: string | null | undefined,
  params: Params | null | undefined,
  knownViewNames: string[],
): string | undefined => {
  return activeTab || readViewNameFromParams(params, knownViewNames) || undefined;
};
